<app-page-list [columns]="columns" [queryService]="service.query" [canInsert]="createPermission" [crud]="service" [canImportExcel]="false" [insertForm]="insertForm" insertFormTitle="punto di campionamento" insertFormSize="full" [filterForm]="filterForm" [visibleColumns]="visibleColumns"
[canExport]="true" [canImport]="true" [excelBtnTitle]="'Esporta punti di campionamento'" (modelChange)="buttonExcelClicked()">
  <div filters>
    <app-filters-form [form]="filters"></app-filters-form>
  </div>
  <div insert-form class="flex flex-column gap-2">
    <!-- <app-punto-campionamento-card [puntoCampionamento]="insertForm.value"></app-punto-campionamento-card> -->
    <app-uuid-form [form]="insertForm"></app-uuid-form>
    <div class="grid">
      <app-card title="Data validità" class="col-6" borderless>
        <app-date-form [form]="insertForm"></app-date-form>
      </app-card>
      <app-card title="Id. ARERA" class="col-6" borderless>
        <app-arera-form [form]="insertForm"></app-arera-form>
      </app-card>
    </div>
    
    <div class="grid">
      <app-card title="Acquedotto" class="col-6" borderless>
        <app-acquedotto-form-insert [form]="insertForm"></app-acquedotto-form-insert>
      </app-card>
      <app-card title="Informazioni" class="col-6" borderless>
        <app-informazioni-form [form]="insertForm"></app-informazioni-form>
      </app-card>
      <app-card title="Controlli" class="col-12 md:col-4 lg:col-4" borderless>
        <app-controlli-form [form]="insertForm"></app-controlli-form>
      </app-card>
      <app-card title="Posizione Geografica" class="col-12 md:col-8 lg:col-8" borderless>
        <app-posizione-geografica-form [form]="insertForm"></app-posizione-geografica-form>
      </app-card>
    </div>
  </div>
</app-page-list>
